import {
  Grid,
  makeStyles,
  Container,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,
  Box,
  Divider,
  Dialog,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React from "react";
import DialogHeader from "../DialogHeader";
import { useState } from "react";
import { useDispatch } from "react-redux";
import StyledDialog from "../../../../../common/models/Dialog";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../../containers/actions/types";
import BackDropLoading from "../../../common/models/BackDrop";

const useStyles = makeStyles((theme) => ({
  list: {
    width: "40vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      width: "80vw",
    },
  },
  backdrop: {
    "& .MuiBackdrop-root ": {
      backgroundColor: "transparent !important",
      opacity: "0 !important",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "90px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute", // Keeps buttons in place
    bottom: "20px", // Positions it near bottom
    width: "90%",
    left: "5%",
  },
  warningContainer: {
    minHeight: "70px", // Reserves space for warning message to prevent movement
  },
}));

const EditWarehouseStatus = (props) => {
  const { warehouseDetails, handleClose,handleRefresh,closeView } = props;
  const classes = useStyles();
  const [status, setStatus] = useState(warehouseDetails.status);
   
    
  
    const [formData, setFormData] = useState(warehouseDetails);
  
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false); // State to manage Backdrop
   const dispatch = useDispatch();
    // const errorRef = useRef();
     
  const [touched, setTouched] = useState(false);  // Track if Save Changes was clicked
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);

  const validateForm = () => {
    let newErrors = {};
  
    if (!status) {
      newErrors.status = "Status is required";
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };
  

  const handleSave = () => {
    setTouched(true); // Mark the form as touched
    const validated = validateForm();
  
    if (validated) {
      dispatch({
        type: OPEN_BACKDROP,
        backdropText: 'Please wait...',
      });
  
      setTimeout(() => {
        dispatch({ type: DESTROY_BACKDROP });
        setSavedSuccessfull(true);
      }, 3000);
    }
  };
  

    const handleCloseSave = () => {
      setSavedSuccessfull(false);
      handleClose()
    closeView()
      handleRefresh()
      
    }
    
  
    const handleCancel = () => {
      handleClose();  // Close the drawer and go back to `ViewEditWarehouse`
    };


  return (
    <React.Fragment>
      <BackDropLoading />
      <div className={classes.list}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ padding: "1rem" }}
        >
          <Grid item xs={12}>
            <DialogHeader header={"Edit warehouse status"} />
          </Grid>
          {/* <Container maxWidth="sm" style={{ background: '#fff', padding: '20px' }}> */}
          {/* <Typography variant="h6" style={{ fontWeight: 'bold' }}>Edit warehouse status</Typography> */}
          <Divider style={{ margin: "10px 0" }} />

      {/* Warehouse Name (Left-aligned at the top) */}
      <Container maxWidth="sm" >
              <Typography variant="h6" className={classes.header}style={{ fontWeight: "500" }}>
                {warehouseDetails.warehouseName}
              </Typography>
              </Container>  

      {/* Status Dropdown */}
      <Container maxWidth="sm" style={{ paddingTop: "1rem" }}>
      <FormControl fullWidth variant="outlined" error={Boolean(errors.status)}>
  <Typography variant="body1" style={{ fontWeight: "500" }}>
    Status <span style={{ color: "red" }}>*</span>
  </Typography>
  <Select value={status} onChange={(e) => setStatus(e.target.value)}
    style={{ height: "35px", fontSize: "14px" }}
  >
    <MenuItem value="Active">Active</MenuItem>
    <MenuItem value="Inactive">Inactive</MenuItem>
  </Select>
  {errors.status && <Typography color="error">{errors.status}</Typography>}
</FormControl>


        {/* Warning Message */}
        <Box className={classes.warningContainer}>
          {status === "Inactive" && (
            <>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: "500",
                  color: "black", // Updated to black text
                  marginTop: "4rem",
                }}
              >
                Warning:
              </Typography>
              <Box
                p={2}
                border="1px solid red"
                bgcolor="#ffe6e6"
                color="red"
                style={{
                  
                  marginTop: "1rem",
                }}
              >
                <Typography variant="body2">
                  Status change: You are changing the warehouse status to
                  inactive. Team members will lose access to this warehouse.
                  You will have to activate the warehouse status to regain
                  access.
                </Typography>
              </Box>
            </>
          )}
        </Box>

        {/* Buttons (Fixed in Place) */}
        <div className={classes.buttonContainer}>
          <Button variant="contained" style={{ backgroundColor: "#f5f5f5", color: "black"  }} onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" style={{ backgroundColor: "#173072", color: "white" }} onClick={handleSave}>
            Save changes
          </Button>
        </div>
      </Container>
           
      </Grid>
      </div>
      <Dialog open={savedSuccessfull} fullWidth>
                    <StyledDialog
                      icons={true}
                      handleClose={handleCloseSave}
                      title={'Warehouse Status saved successfully'}
                    />
                  </Dialog>
      
    </React.Fragment>
  );
};

export default EditWarehouseStatus;
